import { Component, Input, OnChanges, ChangeDetectorRef, PLATFORM_ID, Inject } from '@angular/core'
import { SharedDataService } from 'src/app/core/services/shared-data.service'
import { isPlatformBrowser } from '@angular/common'

@Component({
    selector: 'app-how-to-videos',
    templateUrl: './how-to-videos.component.html',
    styleUrls: ['./how-to-videos.component.scss'],
    standalone: false
})
export class HowToVideosComponent implements OnChanges {

  equipmentProviderInActive: boolean = false;
  constructor(private cdr: ChangeDetectorRef, 
     @Inject(PLATFORM_ID) private platformId: object,
      public sharedDataService: SharedDataService) { 
    this.equipmentProviderInActive = this.sharedDataService.getPortalType()
    // if(this.equipmentProviderInActive){
    //   document?.documentElement?.style?.setProperty('--background-color', '#0072BC')
    // } else {
    //   document?.documentElement?.style?.setProperty('--background-color', '#ea731f')
    // }
    
  }
  @Input() videos: any = []
  @Input() breakpoints: any = [{}]
  showVideoModal = false
  selectedVideo: any = {}
  videosList: any = []
  videoPage = 0

  ngOnChanges() {
    this.cdr.detectChanges()
  }

  videoOnClick(video: any) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.selectedVideo = video
    this.showVideoModal = true
    if (this.breakpoints.extraSmall) {
      this.scrollToContainer()
    }
    else {
      this.scrollToTop()
    }
    setTimeout(() => {
      const e = document.querySelector('#videoModal')
      e.classList.add('fade-in')
    }, 0)

  }

  closeModal() {
    this.showVideoModal = false
  }
  onNavigate(e: number) {
    this.closeModal()
    this.videoPage = e
    this.scrollToTop()
  }
  scrollToTop() {
        if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const e = document.querySelector('#videos')
    e.scrollIntoView({ behavior: 'smooth' })
  }

  scrollToContainer() {
        if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const e = document.querySelector('#videosContainer')
    e.scrollIntoView({ behavior: 'smooth' })
  }

}
